"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColumns = void 0;
require("@veeam/components");
const constants_1 = require("../../../constants");
require("../../../core");
const getColumns = (displayedColumns, titles, encryption) => {
    return [
        {
            id: 'name',
            sortKey: 'name',
            title: titles.name,
            width: 150,
            cell: (data) => data.name || constants_1.EMPTY_TEXT.dash,
        },
        {
            id: 'regionName',
            sortKey: 'regionName',
            title: titles.region,
            hidden: !displayedColumns.region,
            width: 150,
            cell: (data) => data.regionName || constants_1.EMPTY_TEXT.dash,
        },
        {
            id: 'isEncrypted',
            sortKey: 'isEncrypted',
            title: titles.encryption,
            hidden: !displayedColumns.encryption,
            width: 150,
            cell: (data) => (data.isEncrypted ? encryption.trueValue : encryption.falseValue),
        },
        {
            id: 'folderName',
            sortKey: 'folderName',
            title: titles.folder,
            hidden: !displayedColumns.folder,
            width: 150,
            cell: (data) => data.folderName || constants_1.EMPTY_TEXT.dash,
        },
        {
            id: 'description',
            sortKey: 'description',
            title: titles.description,
            hidden: !displayedColumns.description,
            cell: (data) => data.description || constants_1.EMPTY_TEXT.dash,
        },
    ];
};
exports.getColumns = getColumns;
//# sourceMappingURL=getColumns.js.map